'use client';

import { useAppConfiguration } from '@/features/app-config';
import { ThemeProvider as NextThemeProvider } from 'next-themes';
import { ReactNode } from 'react';
import { getEnvVar } from '@vimond/utils/env';

const validThemes = ['system', 'light', 'dark'];
type Theme = (typeof validThemes)[number];

const defaultThemeEnv = getEnvVar('NEXT_PUBLIC_DEFAULT_THEME');

const defaultTheme: Theme = validThemes.includes(defaultThemeEnv as Theme)
  ? (defaultThemeEnv as Theme)
  : 'system';

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const { themeBrandColor } = useAppConfiguration();
  const style =
    themeBrandColor &&
    `:root {
            --color-brand: ${themeBrandColor};
        }
        :root[class=light] {
            --color-brand: ${themeBrandColor};
        }
    `;

  return (
    <NextThemeProvider
      attribute="class"
      themes={validThemes}
      defaultTheme={defaultTheme}
      enableSystem={defaultTheme === 'system'}
    >
      <style>{style}</style>
      {children}
    </NextThemeProvider>
  );
};
